import React, { useState } from 'react';
import type { ReactNode } from 'react';

import IconArrowRight from 'components/IconArrowRight';
import IconArrowLeft from 'components/IconArrowLeft';

type Props = {
  className?: string;
  children?: ReactNode;
  gridClass?: String;
};

const CardScroll = ({ gridClass, className, children }: Props) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const childrenArr = React.Children.toArray(children);
  const slideCount = childrenArr.length;

  return (
    <div className={` ${className ? className : ''}`}>
      <section className={`scrolling-touch scrollbar-none -my-48 overflow-x-auto ${className ? className : ''}`}>
        <div className="container flex flex-row flex-nowrap overflow-visible py-80 lg:max-w-screen-md">
          <div
            className={`grid gap-16 transition duration-500 ease-in-out sm:gap-32 ${gridClass ? gridClass : ''}`}
            style={{
              width: `${slideCount * 100}%`,
              transform: `translateX(${(100 / slideCount) * -(currentSlide - 1)}%)`,
              gridTemplateColumns: `repeat(${slideCount}, 1fr)`,
            }}
          >
            {slideCount > 0 &&
              childrenArr.map((child, i) => (
                <div className="item flex items-stretch" key={`slide_${i}`}>
                  {React.isValidElement(child) && React.cloneElement(child)}
                </div>
              ))}
          </div>
        </div>
      </section>

      <div className="container relative -mb-32 flex gap-8 lg:-mb-64 lg:max-w-screen-md">
        <div className="flex-grow"></div>

        <button className="btn-info btn" disabled={currentSlide === 1} onClick={() => setCurrentSlide(currentSlide - 1)}>
          <IconArrowLeft />
        </button>

        <button className="btn-info btn" disabled={currentSlide === slideCount} onClick={() => setCurrentSlide(currentSlide + 1)}>
          <IconArrowRight />
        </button>
      </div>
    </div>
  );
};

export default CardScroll;
